import { locales } from '../i18n';

const contact = {
  whatsapp: 'https://wa.me/5555996271442',
  email: 'equipe.onnix@gmail.com',
  instagram: 'https://www.instagram.com/onnixdev/',
  linkedin: 'https://www.linkedin.com/company/onnix-dev/',
};

export const contactMessages = locales['pt-BR'].contactMessages;
export const getContactMessages = (locale) => (locales[locale] || locales['pt-BR']).contactMessages;

export const hasCompleteWhatsAppNumber = (url = contact.whatsapp) => {
  const match = /^https:\/\/wa\.me\/(55\d+)$/.exec(url);
  return Boolean(match && /^55\d{2}\d{8,9}$/.test(match[1]));
};

export const getWhatsAppUrl = (message) => {
  const url = new URL(contact.whatsapp);
  if (message) url.searchParams.set('text', message);
  return url.toString();
};

export default contact;
